import React, { useState } from 'react';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { Check } from 'lucide-react';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const [form, setForm] = useState({ name: '', email: '', whatsapp: '', password: '', referral_code: sp.get('ref') || '' });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...form };
      if (!payload.referral_code) delete payload.referral_code;
      await register(payload);
      toast.success('Akun berhasil dibuat');
      navigate('/membership');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Gagal mendaftar');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="hidden lg:flex flex-col justify-center bg-[hsl(var(--brand-ink))] text-white p-12">
        <div className="flex items-center gap-2 mb-8"><div className="h-9 w-9 rounded-lg bg-[hsl(var(--brand-gold))] flex items-center justify-center font-display font-bold text-[hsl(var(--brand-ink))]">G</div><span className="font-display font-bold">Gold Trading Academy</span></div>
        <h2 className="font-display text-3xl font-bold leading-tight">Belajar Gold Market Secara Sistematis</h2>
        <ul className="mt-8 space-y-3">
          {['Kurikulum lengkap 7+ chapter','Quiz, progress & sertifikat','Trading Practice Program','Referral 4 level','AI Gold Tutor'].map(t => (
            <li key={t} className="flex items-center gap-3 text-white/85"><Check className="h-5 w-5 text-[hsl(var(--brand-gold))]" />{t}</li>
          ))}
        </ul>
        <p className="text-xs text-white/50 mt-10 max-w-sm">Trading mengandung risiko. Materi bersifat edukasi, bukan nasihat keuangan/investasi.</p>
      </div>
      <div className="flex items-center justify-center p-4 sm:p-8">
        <Card className="w-full max-w-md p-8">
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-6"><div className="h-9 w-9 rounded-lg bg-[hsl(var(--brand-gold))] flex items-center justify-center font-display font-bold text-[hsl(var(--brand-ink))]">G</div><span className="font-display font-bold">Gold Trading Academy</span></Link>
          <h1 className="font-display text-2xl font-bold">Buat Akun</h1>
          <p className="text-sm text-muted-foreground mt-1">Mulai perjalanan belajar Anda.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Nama Lengkap</Label><Input value={form.name} onChange={set('name')} required data-testid="register-name-input" className="mt-1.5" /></div>
            <div><Label>Email</Label><Input type="email" value={form.email} onChange={set('email')} required data-testid="register-email-input" className="mt-1.5" /></div>
            <div><Label>Nomor WhatsApp</Label><Input value={form.whatsapp} onChange={set('whatsapp')} required placeholder="6281..." data-testid="register-whatsapp-input" className="mt-1.5" /></div>
            <div><Label>Kata Sandi</Label><Input type="password" value={form.password} onChange={set('password')} required minLength={6} data-testid="register-password-input" className="mt-1.5" /></div>
            <div><Label>Kode Referral (opsional)</Label><Input value={form.referral_code} onChange={set('referral_code')} data-testid="register-referral-code-input" className="mt-1.5" /></div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-[hsl(var(--brand-gold))] text-[hsl(var(--brand-ink))] hover:bg-[hsl(var(--brand-gold)/0.9)]" data-testid="register-submit-button">{loading ? 'Memproses...' : 'Create Account'}</Button>
          </form>
          <p className="text-sm text-muted-foreground mt-5 text-center">Sudah punya akun? <Link to="/login" className="font-medium text-foreground underline">Masuk</Link></p>
        </Card>
      </div>
    </div>
  );
}
